export default {"src":"/_next/static/media/bybit.3d842800.svg","height":48,"width":124,"blurWidth":0,"blurHeight":0};